const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};


$(function() {
  $(".trigger-toggle-off").click(function() {
    
    $("span.toggle-on").hide();
    $("span.toggle-off").show();
    
  });

  $(".trigger-toggle-on").click(function() {
    $("span.toggle-off").hide();
    $("span.toggle-on").show();
    $('#size-guide').removeClass('link-active');
  });



  $("#inches").click(function() {
    $('.trigger-toggle-on').removeClass('link-active');
    $('.trigger-toggle-off').addClass('link-active');
  });

  $("#centimeters").click(function() {
    $('.trigger-toggle-on').addClass('link-active');
    $('.trigger-toggle-off').removeClass('link-active');
  });


  



});


$('.product__swatch_color').on('click',function(){
  let color = $(this).attr('title');
  $('.js-colorLabel').find('.color-value-spn').text(color);
  $(".js-ProductSwatch label.active").removeClass("active"); 
  $(this).addClass("active"); 
})



function readMore() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Read more"; 
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Read less"; 
    moreText.style.display = "inline";
  }
}




